import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Footer extends Component {
  render() {
    return (
        <div id="footer" className="page page6"> 
          <div className="footer-content">
              <h1>More Stuff</h1>
              <NavLink to="/booklist">Booklist</NavLink>
              <NavLink to="/gallery">Personal Art Gallery</NavLink>
              <NavLink to="/essays">All Essays</NavLink>
              <NavLink to="/videos">Videos</NavLink>
              <NavLink>Henserver.com 2023</NavLink>
          </div>
        </div>
    );
  }
}

export default Footer;
